import React from 'react';
import c from 'classnames';

interface Props extends React.ComponentProps<'div'> {}

const DefinitionRow: React.FC<Props> = ({
  children,
  className,
  ...rest
}) => {
  const classes = c('mo-definition-list__row', className);

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
};

export default DefinitionRow;
